<template>
  <div class="map-view">
    <div class="info">
      <div class="input-item">
        <div class="input-item-prepend">
          <span class="input-item-text">请输入关键字</span>
        </div>
        <input id='tipinput'
               type="text">
      </div>
    </div>
    <div id="MAps"
         ref="map"></div>
  </div>
</template>
<script>
import index from './map.js'

export default {
  ...index,
}
</script>

<style lang="less" scoped>
@import url('./map.less');
</style>
